<template>
    <v-stepper-content step="2">
        <v-form ref="form_beneficio_complementario">
            <v-container fluid grid-list-md>
                <!-- Modal Agregar Beneficio -->
                <v-dialog v-model="abrirModal " :max-width="tamModal" :fullscreen="$root.isTouch" persistent>
                    <v-form ref="form_modal_beneficio_complementario">
                        <v-card>
                            <v-card-title class="bg-title-card">
                                <span class="white--text headline" v-html="objBeneCom.tituloModal"></span>
                            </v-card-title>
                            <v-container fluid grid-list-md>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-autocomplete label="Beneficio Complementario *" color="textbox"
                                            v-model="objBeneCom.idBeneficio" :items="listGeneral.catalogoBeneficios"
                                            item-value="idBeneficio" item-text="beneficio" :rules="requeridoRegla"
                                            autocomplete outlined dense />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" v-if="!tipoPorcentaje">
                                        <v-text-field label="Costo *" color="textbox" v-model="objBeneCom.valor"
                                            :rules="_.concat(requeridoRegla,decimal)" outlined dense/>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-else>
                                        <v-text-field label="Porcentaje*" color="textbox" v-model="objBeneCom.valor"
                                            :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense/>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Estado *" color="textbox" v-model="objBeneCom.idEstado"
                                            :items="listGeneral.listaEstados" item-value="id_estado"
                                            item-text="nombre_estado" :rules="requeridoRegla" autocomplete outlined dense />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col class="text-right">
                                        <v-btn outlined rounded color="danger" class="mr-1" @click="cerrarModal">Salir</v-btn>
                                        <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-dialog>
                <!-- Fin Modal -->
                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-btn rounded dark color="primary" class="float-right" @click="abrirModal = true">NUEVO</v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objBeneCom.idEstadoBusqueda"
                            :items="listGeneral.listaTodosEstados" item-value="id_estado" item-text="nombre_estado"
                            autofocus outlined @change="onFiltrarPorEstado" dense/>
                    </v-col>
                    <v-col cols="12" sm="2"></v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objBeneCom.busqueda" clearable prepend-inner-icon="search" dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col xs12>
                        <v-data-table :search="objBeneCom.busqueda" :headers="listGeneral.cabeceraBeneficios"
                            :items="listaDetalle" class="elevation-3">
                            <template v-slot:item.accion="{ item }">
                                <v-icon small @click="onEditar(item)">edit</v-icon>
                            </template>
                            <template v-slot:pageText="props">
                                Registro del <span v-text="props.pageStart"></span> al <span
                                    v-text="props.pageStop"></span> de <span v-text="props.itemsLength"></span>
                            </template>
                            <template v-slot:no-results>
                                <v-alert :value="true" color="blue" icon="info" style="height:5%">
                                    Tu búsqueda de "<span v-text="objBeneCom.busqueda"></span>" no arrojó resultados.
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col class="text-right">
                        <v-btn outlined rounded color="danger" class="mr-1" @click="previous">Anterior</v-btn>
                        <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-stepper-content>
</template>

<script>
    export default {
        props: ['cargar', 'objForm', 'listGeneral', 'parametros'],
        inject: ['previous', 'onListar', 'next'],
        data() {
            return {
                listaDetalle: [],
                abrirModal: false,
                objBeneCom: {},
            }
        },
        watch: {
            cargar() {
                this.listaDetalle = this.listGeneral.listaBeneficios;
                if (this.cargar && _.size(this.listGeneral.listaBeneficios) == 0) {
                    this.cargaGeneral();
                }
            }
        },
        computed:{
            tipoPorcentaje(){
                var o = _.find(_.get(this.listGeneral,'catalogoBeneficios',[]),{'idBeneficio':this.objBeneCom.idBeneficio});
                if(parseInt(_.get(o,'idTipoCalculo',0)) == this.parametros.idTipoCalculoPorcBeneficioComplementario)
                    return true;
                else
                    return false;
            }
        },
        methods: {
            cargaGeneral() {
                this.objBeneCom = _.clone(this.objForm);
                this.objBeneCom.tituloModal = 'Incluir Beneficio Complementario';
                this.objBeneCom.idEstadoBusqueda = '1';

                var request = [];
                if (_.size(this.listGeneral.cabeceraBeneficios) == 0)
                    request = [
                                this.onListarBeneficios('L_COMBO', 'catalogoBeneficios'), 
                                this .onListarCabeceraBeneficios(), 
                                this.onListarBeneficios('LISTAR_BENEFICIOS', 'listaBeneficios')
                            ];
                else
                    request = [
                                this.onListarBeneficios('L_COMBO', 'catalogoBeneficios'), 
                                this.onListarBeneficios('LISTAR_BENEFICIOS', 'listaBeneficios')
                            ];

                Promise.all(request);
            },
            onListarBeneficios(opcion, lista) {
                var objeto = {
                    'opcion': opcion,
                    'id_aseguradora': this.objBeneCom.idAseguradora,
                    'id_seguro': this.objBeneCom.idSeguro,
                    'id_producto': this.objBeneCom.idProducto,
                    'id_estado': this.parametros.idEstadoDefault
                };

                this.onListar(`administrador/beneficioComplementario/listar`, objeto)
                    .then((respuesta) => {
                        if (_.size(respuesta.data.data) > 0) {
                            this.$set(this.listGeneral, lista, respuesta.data.data);
                        } else
                            mensajesAlerta(respuesta.data.mensaje, 'I');
                        if (lista == 'listaBeneficios')
                            this.listaDetalle = _.clone(this.listGeneral.listaBeneficios);
                    }).catch((e) => {
                        mensajesAlerta(mensajeEstandar.errorPeticion, 'I');
                    });
            },
            onListarCabeceraBeneficios() {
                return this.onListar(`administrador/producto/listar`, {'opcion': 'CAB_BENEFICIOS'})
                    .then((respuesta) => {
                        if (_.size(respuesta.data.data) > 0) {
                            this.$set(this.listGeneral, 'cabeceraBeneficios', respuesta.data.data);
                        } else
                            mensajesAlerta(respuesta.data.mensaje, 'I');

                        return respuesta;
                    })
            },
            onFiltrarPorEstado() {
                this.listaDetalle = _.filter(this.listGeneral.listaBeneficios, (obj) => { return parseInt(obj.idEstado) == parseInt(this.objBeneCom.idEstadoBusqueda) });
                this.listaDetalle = parseInt(this.objBeneCom.idEstadoBusqueda) == 0 ? _.clone(this.listGeneral.listaBeneficios) : this.listaDetalle;
            },
            validar() {
                if (_.size(this.listGeneral.listaBeneficios) > 0)
                    this.next();
                else
                    mensajesAlerta(mensajeEstandar.faltaInformación, 'I');
            },
            // Modal
            validarModal() {
                try {
                    if (!this.$refs.form_modal_beneficio_complementario.validate()) throw mensajeEstandar.corregirInformacion;

                    var beneficio = _.find(this.listGeneral.catalogoBeneficios, (o) => { return parseInt(o.idBeneficio) == this.objBeneCom.idBeneficio });

                    var estado = _.find(this.listGeneral.listaEstados, (o) => { return parseInt(o.id_estado) == parseInt(this.objBeneCom.idEstado) });

                    this.objBeneCom.estado    = _.size(estado) > 0 ? estado.nombre_estado : '';
                    this.objBeneCom.beneficio = _.size(beneficio) > 0 ? beneficio.beneficio : '';
                    this.objBeneCom.valor     = Number.parseFloat(this.objBeneCom.valor).toFixed(2);

                    if (_.isUndefined(this.objBeneCom.index)) {
                        if (this._validarInformacion(this.listGeneral.listaBeneficios, null, this.objBeneCom.idBeneficio, 'idBeneficio')) throw mensajeEstandar.beneficioExistente;
                            this.listGeneral.listaBeneficios.push(_.omit(this.objBeneCom, ['tituloModal', 'idEstadoBusqueda']));
                    } else {
                        if (this._validarInformacion(this.listGeneral.listaBeneficios, this.objBeneCom.index, this.objBeneCom.idBeneficio, 'idBeneficio')) throw mensajeEstandar.beneficioExistente;
                        this.listGeneral.listaBeneficios[this.objBeneCom.index] = _.merge(
                                                                                            this.listGeneral.listaBeneficios[this.objBeneCom.index], 
                                                                                            _.omit(this.objBeneCom, ['tituloModal', 'idEstadoBusqueda'])
                                                                                        );
                    }

                    this.onFiltrarPorEstado();
                    this.cerrarModal();
                } catch (e) {
                    mensajesAlerta(e, 'I');
                }
            },
            onEditar(objeto) {
                this.objBeneCom = _.merge({}, this.objBeneCom, objeto, 
                                            { 
                                                index: _.findIndex(this.listGeneral.listaBeneficios, (o) => { return parseInt(o.idBeneficio) == parseInt(objeto.idBeneficio) }),
                                                tituloModal: 'Editar Beneficio Complementario'
                                            });
                this.abrirModal = true;
            },
            cerrarModal() {
                var estado = this.objBeneCom.idEstadoBusqueda;
                this.$refs.form_modal_beneficio_complementario.resetValidation();
                this.objBeneCom = _.merge({}, _.clone(this.objForm), {
                    idEstado: '1',
                    idEstadoBusqueda: estado,
                    tituloModal: 'Incluir Beneficio Complementario'
                });
                this.abrirModal = false;
            },
        }
    }
</script>